// Import for Font Awesome icons

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faExclamationSquare } from '@fortawesome/pro-solid-svg-icons/faExclamationSquare';
import { faSitemap } from '@fortawesome/pro-solid-svg-icons/faSitemap';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faEye } from '@fortawesome/pro-regular-svg-icons/faEye';
import { faShoppingCart } from '@fortawesome/pro-regular-svg-icons/faShoppingCart';
import { faComments } from '@fortawesome/pro-regular-svg-icons/faComments';
import { faUserTag } from '@fortawesome/pro-regular-svg-icons/faUserTag';
import { faEdit } from '@fortawesome/pro-regular-svg-icons/faEdit';
import { faCommentAltLines } from '@fortawesome/pro-regular-svg-icons/faCommentAltLines';
import { faShopify } from '@fortawesome/free-brands-svg-icons/faShopify';

import { library } from '@fortawesome/fontawesome-svg-core';

library.add(
  faShopify,
  faUser,
  faLock,
  faEnvelope,
  faArrowLeft,
  faExclamationTriangle,
  faExclamationSquare,
  faPlus,
  faUserPlus,
  faEye,
  faShoppingCart,
  faComments,
  faUserTag,
  faEdit,
  faCommentAltLines,
  faSitemap,
  faCaretDown,
);
